@if (lspLogoUrl) {
  <img
    class="lsp-logo non-responsive-lg"
    height="30px"
    [src]="lspLogoUrl"
    alt="Logo"
  />
}
<div class="header">
  <div class="top-nav-bar top-0 position-fixed w-100">
    <div class="d-flex header-flex text-light align-items-center h-100">
      <div
        (click)="navigateTo('/management')"
        (keypress)="navigateTo('/management')"
        tabindex="auto"
        class="h6 mt-2 button-orange py-2 px-3"
        [innerHTML]="'management.toolbar.title.content' | translate"
      ></div>
    </div>
    @if (loggedIn) {
      <button
        mat-icon-button
        class="text-white non-responsive settings-button-non-reponsive"
        aria-label="Settings icon"
        [routerLink]="['/management/settings']"
        routerLinkActive="router-link-active"
      >
        <mat-icon>settings</mat-icon>
      </button>
    }
    <div class="bg-white language-selection-button non-responsive">
      <mat-form-field class="small" appearance="fill" *mcRerender="trigger">
        <mat-label
          [innerHTML]="'toolbar.language_selection_title.content' | translate"
        ></mat-label>
        <mat-select [(ngModel)]="lang" (selectionChange)="translate.use(lang)">
          @for (lang of translate.getLangs(); track lang) {
            <mat-option [value]="lang">
              {{ 'languages.' + lang | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (loggedIn) {
      <button
        mat-icon-button
        (click)="openLogoutConfirmationDialog()"
        class="text-white non-responsive logout-button-non-reponsive"
        aria-label="Logout icon"
      >
        <mat-icon>power_settings_new</mat-icon>
      </button>
    }
    <div class="responsive">
      <button
        mat-icon-button
        class="text-white menu-button-reponsive"
        [matMenuTriggerFor]="menu"
        aria-label="Open menu button"
      >
        <mat-icon class="menu-icon">menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (loggedIn) {
          <button
            mat-menu-item
            [routerLink]="['/management/settings']"
            routerLinkActive="router-link-active"
          >
            <mat-icon>settings</mat-icon>
            {{ 'case_management_portal.settings.heading.content' | translate }}
          </button>
        }
        @if (loggedIn) {
          <button mat-menu-item (click)="openLogoutConfirmationDialog()">
            <mat-icon>power_settings_new</mat-icon>
            {{ 'footer.logout_button.content' | translate }}
          </button>
        }
        <button mat-menu-item [matMenuTriggerFor]="language_menu">
          <mat-icon>translate</mat-icon>
          {{ 'toolbar.language_selection_title.content' | translate }}
        </button>
        <mat-menu #language_menu="matMenu">
          @for (lang of translate.getLangs(); track lang) {
            <button mat-menu-item (click)="translate.use(lang)">
              <span [innerHTML]="'languages.' + lang | translate"></span>
            </button>
          }
        </mat-menu>
      </mat-menu>
    </div>
  </div>
</div>
<div class="content">
  <router-outlet></router-outlet>
</div>
